<script>
import { createDrawingTool } from './drawing-tool.js'
export default createDrawingTool('CrossLineTool', function() {
            return {
                // Descriptor for the tool
                group: 'Lines', category: 'Lines', icon: this.getIcon('cross_line'),
                type: 'Segment',
                name: 'Cross Line',
                hint: 'This hint will be shown on hover',
                data: [],     // Default data
                settings: {}, // Default settings
            }
        }, 'Cross Line')
</script>
